import { Alert, Card, Form, Input, Select, type FormInstance } from 'antd'
import { useTranslation } from 'react-i18next'

import type { SettlementAccountCreate } from '@repo/sdk'

import { useBankOptions } from './useBankOptions'

interface SettlementAccountFormProps {
  form: FormInstance<SettlementAccountCreate>
  initialValues?: Partial<SettlementAccountCreate>
}

export function SettlementAccountForm({ form, initialValues }: SettlementAccountFormProps) {
  const { t } = useTranslation()
  const bankOptions = useBankOptions()

  return (
    <Form form={form} layout="vertical" preserve={false} initialValues={initialValues}>
      <Card
        title={t('pages.settlements.sections.registrationForm')}
        size="small"
        style={{ maxWidth: 600 }}
      >
        <Form.Item
          name="bankName"
          label={t('common.formLabels.bank')}
          rules={[{ required: true, message: t('pages.settlements.validation.bankRequired') }]}
        >
          <Select
            data-testid="settlement-account-bank-select"
            showSearch
            placeholder={t('pages.settlements.placeholders.bank')}
            options={bankOptions}
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
          />
        </Form.Item>

        <Form.Item
          name="accountNumber"
          label={t('common.formLabels.accountNumber')}
          rules={[
            { required: true, message: t('pages.settlements.validation.accountNumberRequired') },
            {
              min: 8,
              message: t('pages.settlements.validation.accountNumberMinLength', { min: 8 }),
            },
            {
              pattern: /^[\d-]+$/,
              message: t('pages.settlements.validation.accountNumberPattern'),
            },
          ]}
        >
          <Input
            data-testid="settlement-account-number-input"
            placeholder={t('pages.settlements.placeholders.accountNumber')}
          />
        </Form.Item>

        <Alert
          type="info"
          showIcon
          message={t('pages.settlements.registrationNotice')}
          style={{ marginBottom: 16 }}
        />
      </Card>
    </Form>
  )
}
